module.exports = __webpack_public_path__ + "media/images/svg/logo-nsud-4086375ba75799dfb22c7b6ed435ce35.svg";